export class DataMessageGridColumnsModel {
	private entity: string;

	constructor(entity: string) {
		this.entity = entity;
	}

	/**
	 * Return columns configuration.
	 * @param appScopes
	 * @param acuities
	 */
	getColumns(): Array<any> {
		let columns: Array<any> = [];

		switch (this.entity) {
			case 'milestone-message':
				columns = [
					{
						headerName: 'Origin',
						field: 'origin',
						width: 120,
						resizable: true
					},
					{
						headerName: 'Status',
						field: 'status',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Message',
						field: 'message',
						width: 220,
						resizable: false
					},
					{
						headerName: 'Actions',
						width: 100,
						cellRenderer: 'customActionCellComponent'
					}
				];
				break;
			case 'data-message-type':
				columns = [
					{
						headerName: 'Data Message Attribute',
						field: 'nexsysAttribute',
						width: 120,
						resizable: true
					},
					{
						headerName: 'AppScope',
						field: 'appScopeType',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Acuity',
						field: 'acuityType',
						width: 120,
						resizable: false
					},
					{
						headerName: 'CMP Acuity',
						field: 'cmpAcuityType',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Actions',
						width: 100,
						cellRenderer: 'customActionCellComponent'
					}
				];
				break;
			case 'lender-company-message':
				columns = [
					{
						headerName: 'LenderCompanyId',
						field: 'nexsysLenderCompanyId',
						width: 120,
						resizable: true
					},
					{
						headerName: 'AppScope',
						field: 'appScopeMessage',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Acuity',
						field: 'acuityMessage',
						width: 120,
						resizable: false
					},
					{
						headerName: 'CMP Acuity',
						field: 'cmpAcuityMessage',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Actions',
						width: 100,
						cellRenderer: 'customActionCellComponent'
					}
				];
				break;
			case 'assets-on-completion':
				columns = [
					{
						headerName: 'Origin',
						field: 'origin',
						width: 80,
						resizable: true
					},
					{
						headerName: 'Description',
						field: 'description',
						width: 200,
						resizable: false
					},
					{
						headerName: 'Created By',
						field: 'createdBy',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Updated By',
						field: 'updatedBy',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Updated Date',
						field: 'updated',
						width: 120,
						resizable: false
					},
					{
						headerName: 'Actions',
						width: 100,
						cellRenderer: 'customActionCellComponent'
					}
				];
				break;
		}

		return columns;
	}
}
